// extracted by mini-css-extract-plugin
export default {"modify_order_header":"Ts","center":"Us","empty":"Vs","pending":"Ws","referralTitle":"Xs","wrapper":"Ys","title":"Zs","tabs":"at","tab":"bt","active":"ct","btn":"et","rewards_table":"ft"};
    if(module.hot) {
      // 1743628922658
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  